


































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class UiTreeview extends Vue{
  isChildOpened:{[type: string]: boolean} = {};
  
  @Prop({ default: true })
  isAllOpened: boolean;
  
  @Prop({ default: 0 })
  level: number;
  
  @Prop()
  items: TreeViewItem[];
  
  isOpened(item){
    return this.isAllOpened ? !this.isChildOpened[item.id] : this.isChildOpened[item.id]
  }
  
  clickMainRow(item){
    Vue.set(this.isChildOpened, item.id, !this.isChildOpened[item.id]);
  }
}
